import { AnyAction } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '..';
import { AlertPopupProps } from '../../components/PopupProvider/useAlertPopup';
import { setPopupProps, openPopup } from './popupReducer';

export const openAlertPopup = (
  componentProps: AlertPopupProps
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(
      setPopupProps({
        componentName: 'AlertPopup',
        componentProps: componentProps as unknown as Record<string, unknown>,
      })
    );
    dispatch(openPopup());
  };
};
